// extracted by mini-css-extract-plugin
export default {"upload_image":"RequestEcoTiendaOrMaster_upload_image__mAHKO","form_container":"RequestEcoTiendaOrMaster_form_container__w7ozA"};